export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";
export const USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS";
export const INVALID_CURRENT_PASSWORD_ERROR = "INVALID_CURRENT_PASSWORD_ERROR";
